import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';

// NOTE: <React.StrictMode> was intentionally removed. In development it
// double-invokes every effect, which made every manual useEffect+fetch and
// React Query hook fire twice — showing up as duplicate API calls across all
// tabs in the Network panel. StrictMode has no effect on production builds,
// so this only changes the local dev experience.
ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
